import { Injectable } from "@angular/core"
import { HttpHeaders, HttpClient } from "@angular/common/http"
import { catchError, timeout } from "rxjs/operators"
import { MessageService } from "./login.service"
import { Router } from "@angular/router"
import { AppConfig } from "../config/app-config"

@Injectable({
    providedIn: "root"
})
export class KapraoService {
    apiUrl
    // apiUrl = 'https://api.kaphraothai.com/kphb';
    // apiUrl = 'https://api-test.kaphraothai.com/kphb';
    constructor(
        private http: HttpClient,
        private messageService: MessageService,
        private router: Router,
        private appConfig: AppConfig
    ) {
        this.apiUrl = appConfig.API_URL
        console.log(this.apiUrl)
    }
    checkAuthorize(res) {
        console.log(res?.code)
        if (res?.code == "9908") {
            console.log("redirect to login")
            this.handleLogout()
            return
        }

        console.log(res.status)
        if (res.status == 500 || res.status == 501 || res.status == 502) {
            console.log("redirect to login")
            this.handleLogout()
            // let dialogRef = this.dialog.open(ModalComponent, {
            //   data: {
            //     type: 'error',
            //     message: res.msg,
            //   },
            //   width: '500px',
            //   height: '250px',
            // });
            // dialogRef.afterOpened().subscribe((_) => {
            //   setTimeout(() => {
            //     dialogRef.close();
            //     localStorage.clear();
            //     this.messageService.sendMessage('logout');
            //     this.router.navigate(['/login']);
            //   }, 2000);
            // });
        } else if (res.status == 403) {
            console.log("redirect to ban")
            this.handleLogout("/login")
            // this.router.navigate(['account/info']);
        }
    }
    handleLogout(route = "/login") {
        localStorage.clear()
        this.messageService.sendMessage("logout")
        this.router.navigateByUrl(route)
    }
    login(req) {
        return this.http
            .post(this.apiUrl + "/v1/auth/signIn", req)
            .pipe(timeout(40000))
            .toPromise()
    }
    logout() {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/auth/signOut", httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getProfile() {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/auth/profile", httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then(
                (res: any) => {
                    this.checkAuthorize(res)
                    return res
                },
                (error) => {
                    this.checkAuthorize(error)
                }
            )
    }
    getFood(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/food/inquiryFoodOrderType",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getCategory(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/foodCategory/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getMembership(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/membership/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getBranch(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/branch/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getSubordinate(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/sub/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getPermission() {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/sub/inquiryPermission", httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getEmployee(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/employee/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    uploadImg(req) {
        console.log(req)
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        const formData = new FormData()
        formData.append("file", req.file)
        return this.http
            .post(this.apiUrl + "/v1/img/upload?c=food", formData, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    addFood(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/food/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getFoodID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/food/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    editFood(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/food/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    addCategory(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/foodCategory/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getCategoryID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/foodCategory/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    editCategory(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/foodCategory/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    // getBranchID(id) {
    //   const httpOptions = {
    //     headers: new HttpHeaders({
    //       Authorization: localStorage.getItem('token'),
    //       // 'request-id': Math.floor(Date.now() / 1000).toString(),
    //     }),
    //     // withCredentials: true,
    //   };
    //   return this.http
    //     .get(this.apiUrl + '/v1/foodCategory/get/' + id, httpOptions)
    //     .pipe(timeout(40000))
    //     .toPromise()
    //     .then((res: any) => {
    //       this.checkAuthorize(res);
    //       return res;
    //     });
    // }
    createSub(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/sub/createSubAdmin", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getAnno(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/announcement/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getPromotion(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/promotion/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getNoti(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/notification/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getHelp(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/helpcentre/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getPopular(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/popular/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createBranch(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/branch/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getBranchID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/branch/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    updateBranch(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/branch/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getSubID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/sub/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    updateSub(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/sub/updateSubAdmin", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createPromo(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/promotion/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createPromoNew(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/promotion/createNew", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getPromoID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/promotion/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getPromoIDNew(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/promotion/getNew/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    editPromo(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/promotion/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createAnno(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/announcement/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getAnnoID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/announcement/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    editAnno(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/announcement/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createNoti(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/notification/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getNotiID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/notification/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    editNoti(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/notification/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createHelp(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/helpcentre/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getHelpID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/helpcentre/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    editHelp(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/helpcentre/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createPop(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/popular/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getPopID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/popular/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    editPop(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/popular/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createEmployee(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/employee/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getEmployeeID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/employee/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    editEmployee(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/employee/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    changePassword(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/auth/changePassword", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    updatePassword(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/admin/updateNewPassword", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getReportOrder(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/orderOverview", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getReportDetail(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/orderDetail", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getTransLog(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/logTransaction", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getTransReport(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/txn", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getOTransferReport(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/omise/getTransfer", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getBalance() {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/omise/getBalance", httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getMemberID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/membership/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getPromoReport(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/report/promotionOverview",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getPromoDetail(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/promotionDetail", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getPromotionOrderDetail(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/report/newPromotionOrderDetail",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getReportBranch(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/branch", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getReportBranchT(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/branchT", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getBestSeller(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/bestSeller", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getBestSellerT(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/bestSellert", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getFeedOrder(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/feedbackorder/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getFeedID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/feedbackorder/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getFoodCus(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/foodCustomize/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    createCustomize(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/foodCustomize/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    editCustomize(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/foodCustomize/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getMp(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/mp/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getMpId(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/mp/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getMpUnit(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/mpu/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    createMp(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/mp/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    editMp(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/mp/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getSup(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/supp/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getSuppId(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/supp/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createSupp(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/supp/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    editSupp(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/supp/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getPur(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/pur/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getAppConfig(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/appConfig/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    editAppConfig(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/appConfig/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    editStatusSub(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/sub/updateStatus", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createPur(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/pur/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    purAction(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/pur/action", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    purReceive(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/pur/receive", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getStock(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/stock/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    moveStock(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/stock/createOrderMove", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    orderMove(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/stock/actionOrderMove", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getStockHold(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/stock/inquiryHold", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getPlatform() {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/appVersion/inquiry", httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    createPlatform(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/appVersion/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    editPlatform(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/appVersion/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    createInvoice(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/invoice/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    updateInvoice(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/invoice/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    adjustOrder(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/adjustment/adjustOrder", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    checkPer() {
        return JSON.parse(localStorage.getItem("p"))
    }
    getUnit(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/mpu/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getUnitID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/mpu/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createUnit(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/mpu/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    updateUnit(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/mpu/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getAccCategory(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/accountingCategory/inquiry",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getAccCategoryID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/accountingCategory/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createAccCategory(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/accountingCategory/create",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    updateAccCategory(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/accountingCategory/update",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getIE(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/accounting/inquiryBranch",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getIEByBranch(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/accounting/inquiryByBranch",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getIEByBranchT(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/accounting/inquiryByBranchT",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    createAcc(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/accounting/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getAccID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/accounting/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    updateAcc(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/accounting/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    deleteAcc(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/accounting/delete", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getPartner(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/partner/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getPartnerID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/partner/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getInvoice() {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/invoice/get", httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getInvoiceID(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/invoice/detail", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    createPartner(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/partner/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    updatePartner(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/partner/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    getRedeem(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/redeem/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    createRedeem(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/redeem/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    afterReject(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/pur/afterReject", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getIssue(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/stock/inquiryIssue", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    createIssue(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/stock/issueStock", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    cancelIssue(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/stock/updateIssueStock", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    afterRejectS(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/stock/afterReject", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    approveOrReject(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/stock/approveOrReject", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getRedeemID(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(this.apiUrl + "/v1/redeem/get/" + id, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
    editRedeem(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/redeem/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getPointRate(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/pointrate/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    updatePointRate(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/pointrate/update", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getReportSeller(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/seller", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getReportSellerDetail(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/sellerDetail", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getFoodProcess(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/fcs/inquiry", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getRawMp(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/fcs/inquiryMpAgv", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    createFoodProcessing(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/fcs/create", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getInventoryReport(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/inventoryReport", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getDetailInventoryReport(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/report/newInventoryDetailReport",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getMovementReport(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/stock/inquiryLogStock", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getCostSystem(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/costSystem", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getCostSystemT(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/report/costSystemt", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getIEDashboard(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/accounting/dashBoardAccounting",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getIEDashboardT(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + "/v1/accounting/dashBoardAccountingt",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    editPromoImg(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/promotion/updatePicture", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getAddGroup(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/food/ad/i", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    createAddGroup(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/food/ad/c", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    editAddGroup(req, id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .put(this.apiUrl + "/v1/food/ad/u/" + id, req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getMaterialCat(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/mc/i", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    createMaterialCat(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/mc/c", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    updateMaterialCat(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/mc/u", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    getReportBranchUSA(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                "https://api-test.kaphraoexpress.com/kphb/v1/report/branch",
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    initVideo(req) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(this.apiUrl + "/v1/video/upload/init", req, httpOptions)
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    completeVideo(req, id) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .post(
                this.apiUrl + `/v1/video/upload/${id}/complete`,
                req,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .catch((error) => {
                this.checkAuthorize(error)
                console.error(error)
            })
    }
    inquiryVideo(page, limit) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: localStorage.getItem("token")
                // 'request-id': Math.floor(Date.now() / 1000).toString(),
            })
            // withCredentials: true,
        }
        return this.http
            .get(
                this.apiUrl +
                    `/v1/video/list?category=food&page=${page}&limit=${limit}`,
                httpOptions
            )
            .pipe(timeout(40000))
            .toPromise()
            .then((res: any) => {
                this.checkAuthorize(res)
                return res
            })
    }
}
